module.exports = __webpack_public_path__ + "static/img/267454942149492383fe7c208feef905.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/true_icon.png
// module id = vpXR
// module chunks = 1